<template>
  <v-container fluid grid-list-md align-start>
    <v-card>
      <v-form v-model="forms.valid.main">
        <v-toolbar flat color="white" tabs>
          <v-toolbar-title>{{
            event.id ? $t("edit_event") : $t("create_event")
          }}</v-toolbar-title>
          <!--<h3>{{ event.id ? $t('edit_event') : $t('create_event') }}</h3>-->
        </v-toolbar>

        <v-tabs v-model="tab" grow>
          <v-tabs-slider></v-tabs-slider>
          <v-tab key="1" ripple>Stammdaten</v-tab>
          <!--                    <v-tab key="2" ripple>Kombinationen</v-tab>-->
          <v-tab-item key="1">
            <v-card flat>
              <v-card-text>
                <v-text-field
                  :label="$t('name')"
                  v-model="event.name"
                  :loading="loading"
                  :disabled="loading"
                  :rules="rules.name"
                  @keyup.enter="submit"
                  required
                ></v-text-field>

                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-autocomplete
                      :items="users.items"
                      v-model="event.organizer_id"
                      :label="$t('organizer')"
                      item-value="id"
                      item-text="selectText"
                      :loading="loading"
                      :disabled="loading"
                      clearable
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-select
                      :items="translatedTypes"
                      v-model="event.event_type_id"
                      :label="$t('type')"
                      item-value="id"
                      item-text="name"
                      :loading="loading"
                      :disabled="loading"
                      :rules="rules.eventType"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs4>
                    <v-select
                      :items="[
                        { key: 1, label: 'Rechnungen erstellen' },
                        { key: 2, label: 'Turnier verstecken' },
                      ]"
                      v-model="states"
                      :label="$t('status')"
                      item-value="key"
                      item-text="label"
                      :loading="loading"
                      :disabled="loading"
                      multiple
                    >
                    </v-select>
                  </v-flex>

                  <v-flex xs4>
                    <v-select
                      :items="[
                        { id: 10, label: 'SDF Regeln 2025' },
                        { id: 8, label: 'SDF Regeln 2023 STM' },
                        { id: 9, label: 'SDF Regeln 2023 DM' },
                        { id: 7, label: 'SDF Regeln 2021' },
                        { id: 3, label: 'SDF Regeln 2019' },
                        { id: 2, label: 'WADF Regeln' },
                        { id: 4, label: 'Battle Regeln' },
                        { id: 5, label: 'Videowettbewerb Regeln' },
                        { id: 6, label: 'SDF Solo & Duo' },
                        { id: 1, label: 'SDF Regeln (Alt)' },
                      ]"
                      v-model="event.event_rule_id"
                      :label="$t('event_rules')"
                      item-value="id"
                      item-text="label"
                      :loading="loading"
                      :disabled="loading"
                      :rules="rules.rules"
                      @input="rulesChanged"
                    >
                    </v-select>
                  </v-flex>

                  <v-flex xs4>
                    <v-text-field
                      v-model="event.time_to_pay"
                      label="Tage bis Zahlung (Turnierdatum wenn leer)"
                      :loading="loading"
                      :disabled="loading"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12 sm4>
                    <date-picker
                      v-model="event.register_start"
                      @input="registerStartChanged"
                      label="Registrierungstart"
                      :loading="loading"
                      :disabled="loading"
                      :rules="rules.registerStart"
                      required
                    ></date-picker>
                  </v-flex>

                  <v-flex xs12 sm4>
                    <date-picker
                      v-model="event.register_end"
                      label="Registrierungsende"
                      :loading="loading"
                      :disabled="loading"
                      :rules="rules.registerEnd"
                      required
                    ></date-picker>
                  </v-flex>

                  <v-flex xs12 sm4>
                    <date-picker
                      v-model="event.fake_register_end"
                      label="Meldeschluss"
                      :loading="loading"
                      :disabled="loading"
                      :rules="rules.registerFakeEnd"
                      required
                    ></date-picker>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12 sm6>
                    <date-picker
                      v-model="event.start"
                      label="Turnierstart"
                      :loading="loading"
                      :disabled="loading"
                      :rules="rules.start"
                      required
                    ></date-picker>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <date-picker
                      v-model="event.end"
                      label="Turnierende"
                      :loading="loading"
                      :disabled="loading"
                      :rules="rules.end"
                      required
                    ></date-picker>
                  </v-flex>
                </v-layout>

                <v-text-field
                  :label="$t('host')"
                  v-model="event.host"
                  :loading="loading"
                  :disabled="loading"
                  :rules="rules.host"
                  @keyup.enter="submit"
                  required
                ></v-text-field>

                <v-layout row>
                  <v-flex xs9>
                    <v-text-field
                      :label="$t('street')"
                      v-model="event.street"
                      :loading="loading"
                      :disabled="loading"
                      :rules="rules.street"
                      @keyup.enter="submit"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      :label="$t('street_number')"
                      v-model="event.street_number"
                      :loading="loading"
                      :disabled="loading"
                      :rules="rules.street_number"
                      @keyup.enter="submit"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs3>
                    <v-text-field
                      :label="$t('postcode')"
                      v-model="event.postcode"
                      :loading="loading"
                      :disabled="loading"
                      :rules="rules.postcode"
                      @keyup.enter="submit"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                      :label="$t('town')"
                      v-model="event.town"
                      :loading="loading"
                      :disabled="loading"
                      :rules="rules.town"
                      @keyup.enter="submit"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-autocomplete
                      :items="countries"
                      item-value="code"
                      item-text="name"
                      v-model="event.country"
                      :label="$t('country')"
                      :rules="rules.country"
                      :loading="loading"
                      :disabled="loading"
                      required
                    >
                    </v-autocomplete>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex
                    xs3
                    v-for="type in starterTypes.items.filter(
                      (t) =>
                        t.has_styles &&
                        t.event_rule_id === this.event.event_rule_id,
                    )"
                    :key="type.id"
                  >
                    <v-select
                      :items="selectableStyles"
                      v-model="event.types[type.id]"
                      :label="'Styles ' + $t(type.name)"
                      item-value="id"
                      item-text="name"
                      :loading="loading"
                      :disabled="loading"
                      multiple
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex
                    xs3
                    v-for="type in starterTypes.items.filter(
                      (t) =>
                        !t.has_styles &&
                        t.event_rule_id === this.event.event_rule_id,
                    )"
                    :key="type.id"
                  >
                    <v-checkbox
                      v-model="event.types[type.id]"
                      :label="'Startertyp ' + $t(type.name)"
                      :loading="loading"
                      :disabled="loading"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>

                <event-prices
                  v-model="event.event_prices"
                  :event="event"
                  :disabled="loading"
                  :loading="loading"
                  @validationUpdated="(v) => (this.forms.valid.prices = v)"
                ></event-prices>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="2">
            <event-starter-type-combinations
              v-model="event.starter_type_combinations"
              :event="event"
              :disabled="loading"
              @validationUpdated="(v) => (this.forms.valid.combinations = v)"
            ></event-starter-type-combinations>
          </v-tab-item>
        </v-tabs>

        <v-flex xs12>
          <v-btn
            class="btn-save"
            color="primary"
            @click="submit"
            :disabled="!valid || loading"
            >{{ $t("save") }}</v-btn
          >
          <v-btn :disabled="loading" @click="cancel">{{ $t("cancel") }}</v-btn>
        </v-flex>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DatePicker from "../common/DatePicker";
import EventPrices from "./EventPrices";
import EventStarterTypeCombinations from "./EventStarterTypeCombinations";
import Countries from "../../mixins/countries";

export default {
  components: {
    "date-picker": DatePicker,
    "event-prices": EventPrices,
    "event-starter-type-combinations": EventStarterTypeCombinations,
  },
  mixins: [Countries],
  data() {
    return {
      $validates: true,
      tab: null,
      event: {
        id: null,
        name: null,
        event_type_id: null,
        event_rule_id: null,
        organizer_id: null,
        register_start: null,
        register_end: null,
        fake_register_end: null,
        start: null,
        end: null,
        host: null,
        street: null,
        street_number: null,
        postcode: null,
        town: null,
        country: null,
        event_prices: [],
        time_to_pay: 14,
        types: {},
        states: 0,
        starter_type_combinations: [],
      },
      states: [],
      loading: false,
      forms: {
        valid: {
          main: false,
          combinations: false,
          prices: false,
        },
      },
      rules: {
        name: [(v) => !!v || "Name fehlt"],
        start: [(v) => !!v || "Startdatum fehlt"],
        end: [(v) => !!v || "Enddatum fehlt"],
        registerStart: [(v) => !!v || "Rigistrierungsstart fehlt"],
        registerEnd: [(v) => !!v || "Registrierungsende fehlt"],
        registerFakeEnd: [(v) => !!v || "Meldeschluss fehlt"],
        host: [(v) => !!v || "Location fehlt"],
        street: [(v) => !!v || "Straße fehlt"],
        street_number: [(v) => !!v || "Hausnummer fehlt"],
        postcode: [(v) => !!v || "PLZ fehlt"],
        town: [(v) => !!v || "Stadt fehlt"],
        country: [(v) => !!v || "Land fehlt"],
        rules: [(v) => !!v || "Regelwerk fehlt"],
        eventType: [(v) => !!v || "Turnierart fehlt"],
      },
    };
  },
  computed: {
    valid() {
      return _.every(this.forms.valid, (value) => value);
    },
    selectableStyles() {
      return this.starterStyles.items.filter(
        (s) => s.event_rule_id === this.event.event_rule_id,
      );
    },
    translatedTypes() {
      let items = [];

      _.each(this.eventTypes.items, (type) => {
        items.push({
          id: type.id,
          name: this.$t(type.name),
        });
      });

      return items;
    },
    ...mapState([
      "events",
      "eventTypes",
      "users",
      "starterTypes",
      "starterStyles",
    ]),
  },
  mounted() {
    if (
      this.$route.params.id === undefined &&
      this.$route.query.base_event_id !== undefined
    ) {
      this.loadEvent(this.$route.query.base_event_id);
      this.event.id = null;
    } else if (this.$route.params.id !== undefined) {
      this.loadEvent(this.$route.params.id);
    }
  },
  methods: {
    loadEvent(id) {
      this.loading = true;

      this.event.id = parseInt(id);

      axios.get(`/api/v1/events/${id}`).then(
        (response) => {
          if (!response.data.success) {
            return;
          }

          this.event.name = response.data.data.name;
          this.event.event_type_id = response.data.data.event_type_id;
          this.event.event_rule_id = response.data.data.event_rule_id;
          this.event.organizer_id = response.data.data.organizer_id;
          this.event.register_start = response.data.data.register_start;
          this.event.register_end = response.data.data.register_end;
          this.event.fake_register_end = response.data.data.fake_register_end;
          this.event.start = response.data.data.start;
          this.event.end = response.data.data.end;
          this.event.host = response.data.data.host;
          this.event.street = response.data.data.street;
          this.event.street_number = response.data.data.street_number;
          this.event.postcode = response.data.data.postcode;
          this.event.town = response.data.data.town;
          this.event.event_prices = response.data.data.event_prices;
          this.event.starter_type_combinations =
            response.data.data.starter_type_combinations;
          this.event.states = response.data.data.states;
          this.event.country = response.data.data.country;
          this.event.time_to_pay = response.data.data.time_to_pay;

          for (let state = 1; state <= 32; state *= 2) {
            if ((this.event.states & state) === state) {
              this.states.push(state);
            }
          }

          if (response.data.data.event_styles !== undefined) {
            response.data.data.event_styles.forEach((eventStyle) => {
              if (this.event.types[eventStyle.starter_type_id] === undefined) {
                if (eventStyle.starter_style_id) {
                  this.event.types[eventStyle.starter_type_id] = [];
                } else {
                  this.event.types[eventStyle.starter_type_id] = true;
                }
              }

              if (eventStyle.starter_style_id !== null) {
                this.event.types[eventStyle.starter_type_id].push(
                  eventStyle.starter_style_id,
                );
              }
            });
          }

          this.loading = false;
        },
        (errorResponse) => {
          console.log(errorResponse);
          this.loading = false;
        },
      );
    },
    submit() {
      if (!this.valid) {
        console.log("not valid");
        return;
      }

      this.loading = true;

      this.event.states = _.sum(this.states);

      axios.post("/api/v1/events", this.event).then(
        (response) => {
          if (!response.data.success) {
            return;
          }

          this.$store.dispatch("loadEvents");

          this.loading = false;

          this.$router.push("/admin/events");

          this.$store.commit("snackBar", {
            color: "success",
            text: this.$t("was_saved", [response.data.data.name]),
          });
        },
        (errorResponse) => {
          console.log(errorResponse);
          this.loading = false;
        },
      );
    },
    cancel() {
      this.$router.go(-1);
    },
    registerStartChanged(value) {
      this.event.event_prices[0].start = value;
    },
    rulesChanged() {
      this.$set(this.event, "types", {});
    },
  },
};
</script>

<style scoped>
form {
  width: 100%;
}

.btn-save {
  float: right;
}
</style>
